import React, { useState, useEffect } from 'react'
import { Container, Button, Form, Row, Col, Alert } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import V2Layout from '../components/V2Layout'
import axios from 'axios'

const API = ''

const CompanyStatsAdminScreen = () => {
    const [stats, setStats] = useState({
        cnc_total: '',
        lathes_total: '',
        lathes_live_tool: '',
        lathes_roughing: '',
        lathes_five_axis: '',
        facility_size: '',
        facility_size_full: '',
        cleanroom_size: '',
        clean_work_area: '',
        year_founded: ''
    })
    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        axios.get(`${API}/api/company-stats`)
            .then(res => {
                if (res.data) {
                    setStats(res.data)
                }
                setLoading(false)
            })
            .catch(err => {
                console.error('Error fetching stats:', err)
                setErrorMessage('Failed to load company stats.')
                setLoading(false)
            })
    }, [])

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setStats(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setSaving(true)
        setSuccessMessage('')
        setErrorMessage('')

        axios.put(`${API}/api/company-stats`, stats)
            .then(() => {
                setSuccessMessage('Company statistics updated successfully!')
                setSaving(false)
                window.scrollTo({ top: 0, behavior: 'smooth' })
            })
            .catch(err => {
                console.error('Error saving stats:', err)
                setErrorMessage('Failed to save company statistics.')
                setSaving(false)
            })
    }

    if (loading) {
        return (
            <V2Layout pageClass="pfc-admin">
                <section className="py-5" style={{ minHeight: '60vh', background: '#F9F8FC', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <p style={{ color: '#666', fontSize: '1.2rem' }}>Loading settings...</p>
                </section>
            </V2Layout>
        )
    }

    return (
        <V2Layout pageClass="pfc-admin">
            <section className="py-5" style={{ minHeight: 'calc(100vh - 380px)', background: '#F9F8FC' }}>
                <Container style={{ maxWidth: '800px' }}>
                    {/* Header */}
                    <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <Link to="/admin" style={{ color: 'rgb(150, 120, 230)', textDecoration: 'none', fontWeight: 600, fontSize: '0.875rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="19" y1="12" x2="5" y2="12" />
                                    <polyline points="12 19 5 12 12 5" />
                                </svg>
                                Back to Console
                            </Link>
                            <h1 style={{ fontSize: '1.75rem', fontWeight: 800, color: '#1c1c1c', margin: 0 }}>Company Statistics</h1>
                        </div>
                    </div>

                    {successMessage && <Alert variant="success">{successMessage}</Alert>}
                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

                    <Form onSubmit={handleSubmit} style={{ background: '#ffffff', padding: '2.5rem', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.03)', border: '1px solid #e5e3dd' }}>
                        
                        <h3 style={{ fontSize: '1.15rem', fontWeight: 700, borderBottom: '1px solid #e5e3dd', paddingBottom: '0.5rem', marginBottom: '1.5rem', color: '#26215C' }}>General Company Info</h3>
                        
                        <Row style={{ marginBottom: '1.5rem' }}>
                            <Col md={6}>
                                <Form.Group controlId="year_founded">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Year Founded</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="year_founded" 
                                        value={stats.year_founded} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 2004"
                                        required 
                                    />
                                    <Form.Text className="text-muted">Used to calculate Years in Service.</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>

                        <h3 style={{ fontSize: '1.15rem', fontWeight: 700, borderBottom: '1px solid #e5e3dd', paddingBottom: '0.5rem', marginBottom: '1.5rem', color: '#26215C', marginTop: '2rem' }}>Facility Dimensions</h3>
                        
                        <Row style={{ marginBottom: '1.5rem' }}>
                            <Col md={6}>
                                <Form.Group controlId="facility_size">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Facility Size (Abbreviated)</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="facility_size" 
                                        value={stats.facility_size} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 77K"
                                        required 
                                    />
                                    <Form.Text className="text-muted">Used in stats bars and highlights.</Form.Text>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="facility_size_full">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Facility Size (Full Number)</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="facility_size_full" 
                                        value={stats.facility_size_full} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 77,000+"
                                        required 
                                    />
                                    <Form.Text className="text-muted">Used in descriptions and lists.</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: '1.5rem' }}>
                            <Col md={6}>
                                <Form.Group controlId="cleanroom_size">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Clean Room Size (Sq Ft)</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="cleanroom_size" 
                                        value={stats.cleanroom_size} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 2,500"
                                        required 
                                    />
                                    <Form.Text className="text-muted">Cleanroom size in square feet.</Form.Text>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="clean_work_area">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Clean Work Area Size (Sq Ft)</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="clean_work_area" 
                                        value={stats.clean_work_area} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 800"
                                        required 
                                    />
                                    <Form.Text className="text-muted">Clean work area size in square feet.</Form.Text>
                                </Form.Group>
                            </Col>
                        </Row>

                        <h3 style={{ fontSize: '1.15rem', fontWeight: 700, borderBottom: '1px solid #e5e3dd', paddingBottom: '0.5rem', marginBottom: '1.5rem', color: '#26215C', marginTop: '2rem' }}>Machinery &amp; CNC Fleet</h3>
                        
                        <Row style={{ marginBottom: '1.5rem' }}>
                            <Col md={6}>
                                <Form.Group controlId="cnc_total">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>CNC Work Centers (Total)</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="cnc_total" 
                                        value={stats.cnc_total} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 31+"
                                        required 
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="lathes_total">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Total Lathes</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="lathes_total" 
                                        value={stats.lathes_total} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 9"
                                        required 
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: '1.5rem' }}>
                            <Col md={4}>
                                <Form.Group controlId="lathes_live_tool">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Live Tool Lathes</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="lathes_live_tool" 
                                        value={stats.lathes_live_tool} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 6"
                                        required 
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="lathes_roughing">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>Large Roughing Lathes</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="lathes_roughing" 
                                        value={stats.lathes_roughing} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 3"
                                        required 
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="lathes_five_axis">
                                    <Form.Label style={{ fontWeight: 600, fontSize: '0.875rem', color: '#4a4a4a' }}>5-Axis Lathes</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="lathes_five_axis" 
                                        value={stats.lathes_five_axis} 
                                        onChange={handleInputChange} 
                                        placeholder="e.g. 4"
                                        required 
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div style={{ marginTop: '2.5rem', display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                            <Link to="/admin" className="btn btn-outline-secondary" style={{ padding: '0.6rem 1.5rem', fontWeight: 600 }}>Cancel</Link>
                            <Button 
                                type="submit" 
                                disabled={saving}
                                style={{ background: '#26215C', borderColor: '#26215C', padding: '0.6rem 1.5rem', fontWeight: 600 }}
                            >
                                {saving ? 'Saving...' : 'Save Settings'}
                            </Button>
                        </div>
                    </Form>
                </Container>
            </section>
        </V2Layout>
    )
}

export default CompanyStatsAdminScreen
